import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import IoTSolutions from './components/IoTSolutions';
import Services from './components/Services';
import CallToAction from './components/CallToAction';
import Process from './components/Process';
import Technologies from './components/Technologies';
import Skills from './components/Skills';
import Industries from './components/Industries';
import Contact from './components/Contact';
import Footer from './components/Footer';

import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import ProductPage from './pages/ProductPage';
import Rovoconnect from './pages/Rovoconnect';
import Rovovision from './pages/Rovovision';
import Rovopepole from './pages/Rovopepole';
import Visitech from './pages/Visitech';
import OEE from './pages/OEE';
import Andon from './pages/Andon';
import User from './pages/User';


// ✅ New dedicated page

import Product from './components/Product';

function HomePage() {
  return (
    <div id="main-wrapper">
      <Header />
      <div id="content" role="main">
        <Hero />
        <About />
        <IoTSolutions />
        <Services />
        <CallToAction />
        <Process />
        <Product />
        <Technologies />
        <Skills />
        <Industries />
        <Contact />
      </div>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    // Load external scripts
    const scripts = [
      '/vendor/jquery/jquery.min.js',
      '/vendor/bootstrap/js/bootstrap.bundle.min.js',
      '/vendor/jquery-easing/jquery.easing.min.js',
      '/vendor/jquery.appear/jquery.appear.min.js',
      '/vendor/jquery.countTo/jquery.countTo.min.js',
      '/vendor/parallaxie/parallaxie.min.js',
      '/vendor/owl.carousel/owl.carousel.min.js',
      '/vendor/isotope/isotope.pkgd.min.js',
      '/vendor/magnific-popup/jquery.magnific-popup.min.js',
      '/js/theme.js'
    ];

    scripts.forEach(src => {
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      document.body.appendChild(script);
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/solutions" element={<ProductPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/product" element={<ServicesPage />} />
        {/* ✅ Dedicated RovoConnect page */}
        <Route path="/rovoconnect" element={<Rovoconnect />} />
        <Route path="/rovovision" element={<Rovovision />} />
        <Route path="/rovopepole" element={<Rovopepole />} />
        <Route path="/visitech" element= {<Visitech/>}/>
        <Route path="/OEE" element= {<OEE/>}/>
        <Route path="/Andon" element= {<Andon/>}/>
          <Route path="/User" element= {<User/>}/>

      </Routes>
    </Router>
  );
}

export default App;
